import hash from 'object-hash';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { getSuggestedContacts } from '../../../providers/api/contact/contactProvider';
import { SuggestedContact } from '../../../providers/api/dtos/contact';
import { Reference, SuggestedContactReferenceType } from '../../../domain/types';
import { CONTACT_RID } from '../use-contact/useContact';

export const getUseSuggestedContactsRid = (reference: Reference<SuggestedContactReferenceType>) => [
  CONTACT_RID,
  'suggestions',
  hash(reference),
];

export default function useSuggestedContacts(
  reference?: Reference<SuggestedContactReferenceType>,
  options?: SWRConfiguration<SuggestedContact[]>,
): SWRResponse<SuggestedContact[]> {
  const key = reference ? getUseSuggestedContactsRid(reference) : null;

  return useSWR(key, () => getSuggestedContacts(reference!), options);
}
